/** */
import React from 'react';
import { Routes, Route } from 'react-router-dom';
import AnnouncementModule from './announcements/_index';
import AudienceModule from './audience/_index';
import PaymentsModule from './billing/payments/_index';
import { BillingModule } from './billing/_index';
import TenantsModule from './tenants/_index';
import SettingsModule from './settings/_index';
import MemberAreaHeader from './header/header';
import GMDashboard from './dashboard';
import CampaignModule from './campaigns/_index';
import ServerModule from './servers/_index';
import { Transactionals } from './transactionals';
import { UserManagementModule } from './user-management';
import { TutorialModule } from './tutorials/_index';
import { MessagingModule } from './messaging/_index';
import { ContentModule } from './content/_index';
import CustomersModule from './customers/_index';
import IssuesModule from './issues/_index';
import RevOpsModule from './revops/_index';

export const ModuleLayout = ({ setOpenMenuTray }) => {
  return (
    <section className="app-content">
      <MemberAreaHeader onHamburgerClick={() => setOpenMenuTray(true)} />
      <Routes>
        <Route path="/announcements/*" element={<AnnouncementModule />} />
        <Route path="/audiences/*" element={<AudienceModule />} />
        <Route path="/billings/*" element={<BillingModule />} />
        <Route path="/campaigns/*" element={<CampaignModule />} />
        <Route path="/content/*" element={<ContentModule />} />
        <Route path="/customers/*" element={<CustomersModule />} />
        <Route path="/issues/*" element={<IssuesModule />} />
        <Route path="/messaging/*" element={<MessagingModule />} />
        <Route path="/payments/*" element={<PaymentsModule />} />
        <Route path="/revops/*" element={<RevOpsModule />} />
        <Route path="/servers/*" element={<ServerModule />} />
        <Route path="/settings/*" element={<SettingsModule />} />
        <Route path="/tenants/*" element={<TenantsModule />} />
        <Route path="/transactionals/*" element={<Transactionals />} />
        <Route path="/tutorials/*" element={<TutorialModule />} />
        <Route path="/user-management/*" element={<UserManagementModule />} />
        <Route path="/*" element={<GMDashboard />} />
      </Routes>
    </section>
  );
};
